exports.appCommunicationFramework = {
    "constants": {
        "event_names": {
            login: "login",
            signup: "sign_up",
            logout: "logout",
            search_success: "search",
            filter_apply: "filter_apply",
            filter_remove: "filter_remove",
            coupon_apply_success: "coupon_apply_success",
            coupon_apply_error: "coupon_apply_error",
            coupon_remove: "coupon_remove",
            currency_switch: "currency_switch",
            social_click: "social_click",
            form_view: "form_view",
            form_fallout: "form_fallout",
            form_error: "form_error",
            home_section_clicks: "home_section_clicks",
            top_navigation: "top_navigation",
            menu_navigation: "menu_navigation",
            footer_navigation: "footer_navigation",
            add_to_cart: "add_to_cart",
            add_to_wishlist: "add_to_wishlist",
            add_payment_info: "add_payment_info",
            add_shipping_info: "add_shipping_info",
            begin_checkout: "begin_checkout",
            purchase: "purchase",
            refund: "refund",
            remove_from_cart: "remove_from_cart",
            select_item: "select_item",
            view_cart: "view_cart",
            view_item: "view_item",
            view_item_list: "view_item_list"


        },
        "attribute_name": {
            user_type: "user_type",
            user_id: "user_id",
            user_status: "user_status",

        },
        "event_parameters": {
            screenname: "SCREEN_NAME",
            screentype: "screentype",
            pre_screenname: "pre_screenname",
            pre_screentype: "pre_screentype",
            "searchTerm": "searchTerm",
            search_by: "search_by",
            search_type: "search_type",
            filter_type: "filter_type",
            filter_name: "filter_name",
            formname: "form_name",
            formsource: "form_source",
            feildname: "feild_name",
            sectionName: "section_name",
            linkText: "link_text"
        }
    },
    "google_analytics_4": {
        "description": "",
        "custom_events": {
            "event_function": (event_name, event_parameters, user_attributes) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name,
                    event_parameters,
                    user_attributes
                });
            },
            "description": ""
        },
        "ecommerce": {
            view_item_list: (currencyCode, item_list_name, products) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name: "view_item_list",
                    event_parameters: {
                        item_list_name,
                        products,
                        currencyCode
                    }
                });
            },
            select_item: (currencyCode, item_list_name, item_id, item_name, index, item_category, price, quantity) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name: "select_item",
                    event_parameters: {
                        item_list_name,
                        currencyCode,
                        item_id, item_name, index, item_category, price, quantity
                    }
                });
            },
            view_item: (currencyCode, item_list_name, item_id, item_name, index, item_category, price, quantity, item_brand) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name: "view_item",
                    event_parameters: {
                        item_list_name,
                        currencyCode,
                        item_id, item_brand, item_name, index, item_category, price, quantity
                    }
                });
            },
            add_to_cart: (currencyCode, item_list_name, item_id, item_name, item_category, price, quantity) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name: "add_to_cart",
                    event_parameters: {
                        currencyCode,
                        item_list_name,
                        item_id, item_name, item_category, price, quantity
                    }
                });
            },
            remove_from_cart: (currencyCode, item_list_name, item_id, item_name, item_category, price, quantity) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name: "remove_from_cart",
                    event_parameters: {
                        currencyCode,
                        item_list_name,
                        item_id, item_name, item_category, price, quantity
                    }
                });
            },
            add_shipping_info: (currencyCode, item_array) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name: "add_shipping_info",
                    event_parameters: {
                        currencyCode,
                        item_array
                    }
                });
            },
            add_payment_info: (currencyCode, item_array) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name: "add_payment_info",
                    event_parameters: {
                        currencyCode,
                        item_array
                    }
                });
            },
            purchase: (currencyCode, transaction_id,value,tax,shipping,coupon, item_array) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name: "purchase",
                    event_parameters: {
                        transaction_id,
                        value,
                        tax,
                        shipping,
                        coupon,
                        currencyCode,
                        item_array
                    }
                });
            },
            view_cart: (currencyCode, item_array) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name: "view_cart",
                    event_parameters: {
                        currencyCode,
                        item_array
                    }
                });
            },
            "description": ""
        },
        "errors": {
            "event_function": (error_msg, error_code, screenname, pageurl, user_attributes, errorData) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name: "web_error",
                    event_parameters: {
                        error_msg,
                        error_code,
                        screenname,
                        pageurl,
                        errorData
                    },
                    user_attributes
                });
            },
            "description": ""
        },
        "pageload": {
            "event_function": (event_parameters, user_attributes) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name: "SCREEN_VIEW",
                    event_parameters,
                    user_attributes
                });
            },
            "description": ""
        },
        "appload": {
            "event_function": (event_parameters, user_attributes, campaign_parameters) => {
                this.appCommunicationFramework.google_analytics_4.sendEvent({
                    event_name: "app_open",
                    event_parameters,
                    user_attributes,
                    campaign_parameters
                });
            },
            "description": ""
        },
        connection_setup:()=>{
            if(window?.ReactNativeWebView){
            window.ReactNativeWebView.postMessage({
                connection:"webview_react_native",
                passcode:"1234567890"
            });
        }
        },
        sendEvent: (data) => {
            if(localStorage.getItem("isAnalyticsCookieAllowed")==="true" && localStorage.getItem("isMarketingCookieAllowed")==="true"){
                let eventData = JSON.stringify(data);
                if(window?.ReactNativeWebView){
                    window.ReactNativeWebView.postMessage(eventData);
                }
            }
        }
    },
    "appsflyer": {

    }
}